import * as Yup from 'yup'
import {InlineTable} from 'src/feature/bite/component'
import {useFormikContext} from 'formik'

const StoreContact = ({
  loading,
  intl,
  editable,
  setEditable,
}: {
  loading: boolean
  intl: any
  editable: any
  setEditable: any
}) => {
  const {values, handleSubmit, resetForm} = useFormikContext()

  const column = [
    [
      {
        key: 'contactName',
        dataIndex: 'contactName',
        required: true,
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.NAME'}),
        edit: 'input',
        maxLength: 51,
        tooltip: 'The first name of the primary contact person for the business.',
      },
      {
        key: 'contactPhone',
        dataIndex: 'contactPhone',
        formName: 'contactPhone',
        required: true,
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.PHONE'}),
        edit: 'phone',
        tooltip: 'The contact phone number for business-related inquiries.',
      },
      {
        key: 'contactTitle',
        dataIndex: 'contactTitle',
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.TITLE'}),
        edit: 'input',
        maxLength: 51,
        tooltip: 'The title or role of the contact person within the company.',
      },
    ],
    [
      {
        key: 'contactSurname',
        dataIndex: 'contactSurname',
        required: true,
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.SURNAME'}),
        edit: 'input',
        maxLength: 51,
        tooltip: 'The last name of the primary contact person.',
      },

      {
        key: 'contactEmail',
        dataIndex: 'contactEmail',
        required: true,
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.EMAIL'}),
        edit: 'input',
        maxLength: 101,
        tooltip: 'The official email address for corporate communication.',
      },
    ],
  ]

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({id: 'STORE.DETAIL.CONTACT'})}
            </h3>
            <p className='text-muted fw-normal fs-6'>
              {intl.formatMessage({id: 'STORE.DETAIL.CONTACT_TOOLTIP'})}
            </p>
          </div>
        </div>
      </div>
      <div className='card-body p-9'>
        <InlineTable
          loading={loading}
          dataSource={values}
          columns={column}
          editable={editable.contact}
          values={values}
        />
      </div>
      <div className='card-footer d-flex w-100 justify-content-end'>
        {editable.contact ? (
          <div>
            <button
              type='button'
              className='btn btn-primary'
              style={{marginRight: 10}}
              onClick={(e) => {
                e.preventDefault()
                setEditable({
                  overview: false,
                  contact: false,
                  facility: false,
                  socialMedia: false,
                  contract: false,
                  financial: false,
                })
                resetForm()
              }}
            >
              <i className='bi bi-x me-2'></i>
              {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
            </button>
            <button
              type='button'
              className='btn btn-primary'
              disabled={loading}
              onClick={async (e) => {
                await handleSubmit()
              }}
            >
              <i className='bi bi-save2 me-2'></i>
              {loading
                ? intl.formatMessage({id: 'GLOBAL.BUTTON.SAVING'})
                : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
            </button>
          </div>
        ) : (
          <button
            className='btn btn-primary'
            onClick={(e) => {
              e.preventDefault()
              resetForm()
              setEditable({
                overview: false,
                contact: true,
                facility: false,
                socialMedia: false,
                contract: false,
                financial: false,
              })
            }}
          >
            <i className='bi bi-pencil me-2'></i>
            {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
          </button>
        )}
      </div>
    </div>
  )
}

export default StoreContact
